<template>
<div class="chapter">
<div class="inner_page">
<table width="100%">
<tbody><tr>
<td valign="bottom"><p class="h1a">Acknowledgements</p></td>
<td><p class="right1"><img alt="Images" src="images/img7.jpg"/></p></td>
</tr>
</tbody></table>
<p class="noindent">If it were not for the many food cart entrepreneurs taking risks to live their version of the American Dream, this series would not have been documented. Thank you to all who took time to contribute and, equally, to those not represented in this edition. You are all integral parts of the food cart community here in Portland that builds the city’s character.</p>
<p class="indent">I would like to especially acknowledge Steven Shomler, author of <i>Portland Food Cart Stories: Behind the Scenes with the City’s Culinary Entrepreneurs</i>, for his contagious enthusiasm about the stories behind bootstrap chefs. Brett Burmeister of Food Carts Portland, Scott Batchelar of Food Carts 4 Charity and Aaron Wakamatsu of Aaron’s Food Adventures are all highly reputable Food Cart Kings as well, of whom I am deeply appreciative. Thank you, guys, for taking me under your wing and introducing the Trailer Food Diaries to so many incredible food carts in Portland.</p>
<p class="indent">Thank you as always to Callie, Brighton, Patsy and Jimmy and my supportive friends and colleagues. Thank you to The History Press, which made this cookbook series a reality. I’m proud of what we have created and am grateful for the opportunity to be the storyteller. Last but not least, a big, huge thank-you to the incredible Vega family for hosting me again during my time researching for this volume.</p>
<p class="break"> </p>
<p class="image"><img alt="img" src="images/img8.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgement.vue?80b16836